<template>
  <div id="body">
    <home-header></home-header>
    <base-card>
      <!-- details {{ clientInvoice }} -->
      <div id="element-to-convert">
        <div class="row"></div>

        <div class="row">
          <div style="font-family: Sylfaen" class="col-lg-8 fw-b, fs-2 text-decoration-underline text-primary">
            
            THREE BINS SERVICES
          </div>

          <div class="col-lg-4 fs-16 small">
            P.O BOX 57968-00200
            <br />
            Nairobi
            <br />
            Tel: 020-3590933
            <br />
            Mobile: 0706-242403
          </div>
        </div>

        <div v-for="invoice in clientInvoice" :key="invoice.id" class="row">
          <div class="col-lg-8">
            <br />
            <br />
            <br />
            <b>INVOICE TO:</b>
            <br />
            {{ invoice.ClientName }}
            <br />
            {{ invoice.address }}
            <br />
           KRA PIN  {{invoice.kra_pin }}
           <br>
           PHONE: {{ invoice.phone }}
          </div>
          <div class="col-lg-4">
            <b> <p class="text-center text-primary fs-3">INVOICE</p> </b>

            INVOICE NUMBER: {{ invoice.invoice_number }}
            <br />
            INVOICE DATE: {{ new Date(invoice.invoice_date).toLocaleString('nl-NL').split(" ")[0]  }}
            <br />
           Three Bins KRA PIN: P0998DST
           <br>
           
          </div>
        </div>

        <br />

        <div class="container">
          <table class="table table-bordered">
            <thead>
              <tr class="table-active">
                <th class="w-45">Description</th>
                <th class="">Quantity</th>
                <th class="col-lg-2">Delivery No.</th>
                <th class="col-lg-2">Rate</th>
                <th class="col-lg-2">Amount</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="service in invoiceServices" :key="service.id">
                <!-- <td>{{ court.name }}</td> -->
                <td>{{ service.description }}</td>
                <td>{{ service.quantity }}</td>
                <td>{{ service.delivery_number }}</td>
                <td>{{ service.unity_price }}</td>
                <td>{{ service.unity_price * service.quantity }}</td>

                <!-- <td>{{ new Date(court.reg_date).toLocaleString("nl-NL") }}</td> -->
              </tr>
              <tr>
                <td colspan="2"></td>

                <td class="fw-b fs-6" colspan="2">Sub Total</td>
                <td class="fw-b fs-6">{{ total_amount }}</td>
              </tr>
              <tr>
                <!-- <th rowspan="3"></th> -->
                <td colspan="2"></td>

                <td class="fw-b fs-5" colspan="2">VAT</td>
                <td class="fw-b fs-6">{{ vat }}</td>
              </tr>
             
              <tr  >
                <td colspan="2"></td>
                <!-- <td ></td> -->
                <td colspan="2" class="fw-b fs-4">Invoice Total</td>
                <td class="fw-b fs-5">{{ invoice_total }}</td>
              </tr>
              <!-- <tr>
            <td>
                Payment details
            </td>
        </tr> -->
            </tbody>
          </table>
          Special Instructions:
          <br />
          NO CASH PAYMENTS: MPESA TILL NO: 818378 (Buy goods)
          <br />
          Account Name: Three Bins Services Ltd
          <br />
          <br />
          <div class="row">
            <div class="col-lg-4">
              Family Bank
              <br />
              ACC no: 033000027219
              <br />
              Branch: Donholm
            </div>
            <div class="col-lg-8">
              NCBA Bank
              <br />
              Acc No. 100357475
              <br />
              Branch Lunga Lunga
            </div>
          </div>
        </div>
      </div>

      <!-- <button class="btn btn-primary" @click="exportToPDF">Download form</button> -->
      <!-- <base-button>Download Form</base-button> -->
    </base-card>
    <button class="btn btn-primary" @click="exportToPDF">Download Invoice</button>
  </div>
</template>

<script>
import html2pdf from "html2pdf.js";

export default {
  methods: {
    exportToPDF() {
      var element = document.getElementById("element-to-convert");
      html2pdf(element, {
        margin: [10, 10, 10, 10], //top, left, buttom, right
        filename: this.$route.params.id + ".pdf",
        image: { type: "jpeg", quality: 0.98 },
        html2canvas: {
          dpi: 192,
          scale: 2,
          logging: true,
          letterRendering: true,
        },
        jsPDF: { unit: "mm", format: "a4", orientation: "portrait" },
      });
    },
  },
  // created() {
  //   (this.student_id = this.$route.params.id),
  //     this.$store.dispatch("LoadSecondarystudents");
  //   this.$store.dispatch("LoadVoters");
  // },
  // computed: {
  //   studentdetails() {
  //     return this.$store.getters.secondarystudentsGetter(this.student_id);
  //   },

  // },
  created() {
    (this.invoiceId = this.$route.params.number),
      this.$store.dispatch("LoadInvoiceservices");
    this.$store.dispatch("LoadInvoices");
  },
  computed: {
    invoiceServices() {
      return this.$store.getters.invoiceServices(this.invoiceId);
    },
    // clientInvoice() {
    //   return this.$store.getters.invoices;
    // },
    clientInvoice() {
      return this.$store.getters.getInvoice(this.invoiceId);
    },

    total_amount() {
      let total = 0;
      this.invoiceServices.forEach((val) => {
        total += Number(val.unity_price * val.quantity);
      });
      return total;
    },
    vat() {
      
      return this.total_amount * 0.16;
    },
    invoice_total() {
      return (this.total_amount * 1.16).toFixed(2);
    },
  },
};
</script>
<style scoped>
#body {
  width: 98vw;
  /* height: 100vw; */
  /* background-color: #eaf8d0c9; */
  position: absolute;
  margin-top: 1px;
  left: 20px;
  z-index: 999;
  justify-content: center;
  align-items: center;
}
</style>
